import _ from 'lodash';
import * as types from './action-types';
import { beginApiCall, apiCallError } from './api-status-actions';
import * as dotMailerTrackerApi from '../api/dot-mailer-tracker-api';

export function loadDotMailerTrackerEntriesSuccess(successMessage) {
    return { type: types.LOAD_DOT_MAILER_TRACKER_ENTRIES_SUCCESS, successMessage };
}

export function loadDotMailerTrackerEntriesError(errorMessage) {
    return { type: types.LOAD_DOT_MAILER_TRACKER_ENTRIES_ERROR, errorMessage };
}

export function submitDotMailerTrackData(dotMailerUserEntries, callBackUrl) {
    //eslint-disable-next-line no-unused-vars
    return function (dispatch, getState) {
        dispatch(beginApiCall());
        return dotMailerTrackerApi
            .submitDotMailerTrackData(dotMailerUserEntries, callBackUrl)
            .then((res) => {
                const isResultAnArray = Array.isArray(res);

                if (!isResultAnArray && !res.data) {
                    dispatch(loadDotMailerTrackerEntriesError('User entries could not be saved. Check the logs for more details.'));
                    dispatch(apiCallError());
                    return;
                }

                if (isResultAnArray) {
                    const failedRequestsIndexes = getFailedRequestsIndexes(res);

                    if (!_.isEmpty(failedRequestsIndexes)) {
                        dispatch(loadDotMailerTrackerEntriesError(`Data has been split into ${res.length} batches and batch number: ${failedRequestsIndexes.toString()} finished with errors. Please check the logs for more data.`));
                        dispatch(apiCallError());
                        return;
                    }

                    dispatch(loadDotMailerTrackerEntriesSuccess(`Data has been split into ${res.length} batches and all finished successfully.`));
                    return;
                }

                dispatch(loadDotMailerTrackerEntriesSuccess('User entries saved successfully.'));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadDotMailerTrackerEntriesError());
                throw error;
            });
    };
}

function getFailedRequestsIndexes(result) {
    return result.map((r, index) => {
        if (!r.data) {
            return index;
        }

        return -1;
    }).filter((requestIndex) => requestIndex !== -1);
}
